import React, { Component } from 'react';
import axios from '../../utils/axiosInstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PostDetail.css';
import Facilities from './Facilities';
import GuestReviews from './GuestReviews';
import PostFAQ from './PostFAQ';
import { withNavigation } from '../../utils/withNavigation';

const CANCELLATION_POLICY = [
  '80% of the total booking amount will be refunded if it is cancelled 24 hours before check-in.',
  'No refund is given for cancellations made less than 24 hours before check-in.',
  'No refund is given for no-shows or early departures.',
];

const REPORT_REASONS = [
  "It's inaccurate or incorrect",
  "It's not a real place",
  "It's a scam",
  "It's offensive",
];

const GUEST_OPTIONS = [
  { type: 'rooms', label: 'Rooms', hint: 'Number of rooms' },
  { type: 'adults', label: 'Adults', hint: 'Ages 13 or above' },
  { type: 'children', label: 'Children', hint: 'Ages 2–12' },
];

const stripHtml = (html = '') => String(html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

class PostDetail extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    this.guestRef = React.createRef();

    this.state = {
      hotel: null,
      loading: true,
      error: null,
      bookedDates: [],
      socialData: {
        email: '',
        whatsapp_number: '',
        social_link_1: '',
        social_link_2: '',
        social_link_3: '',
        social_link_4: '',
        powered_by: '',
      },

      checkIn: null,
      checkOut: null,
      leftCalendarBase: firstOfMonth,
      rightCalendarBase: firstOfMonth,
      showSidebarCalendar: false,

      rooms: 1,
      adults: 1,
      children: 0,
      isGuestOpen: false,
      cleaningFee: 0,
      discount: 0,
      post_booking_status: 0,

      isGalleryOpen: false,
      currentImageIndex: 0,
      isShareModalOpen: false,
      copied: false,
      isFavorite: false,

      activeModal: null,
      reportForm: { title: '', description: '' },
      reportSubmitting: false,
      reportError: '',
      reportSubmitted: false,

      remarks: '',
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('mousedown', this.handleOutsideClick);

    this.fetchFooterData();
    const id = this.props.params?.id;

    if (id) {
      this.loadPost(id);
      this.fetchBookedDates(id);
      this.updateRecentlyViewed(id);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mousedown', this.handleOutsideClick);
    document.body.style.overflow = 'unset';
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get('/theme_customizable', {});
      if (res?.data?.data) {
        this.setState(p => ({ socialData: { ...p.socialData, ...res.data.data } }));
      }
      const res1 = await axios.get('/setting', {});
      if (res1?.data?.data) {
        this.setState(p => ({ socialData: { ...p.socialData, powered_by: res1.data.data.powered_by || '' } }));
      }
    } catch (error) {
      console.error('Footer fetch error:', error);
    }
  };

  loadPost = async (postId) => {
    this.setState({ loading: true, error: null });
    try {
      const res = await axios.get(`/get_post_by_id?id=${postId}`);
      const data = Array.isArray(res.data?.data) ? res.data.data[0] : res.data.data;

      if (!data) {
        this.setState({ error: 'Property not found', loading: false });
        return;
      }

      let gallery = [];
      try {
        const parsedGallery = data.gallery_images ? JSON.parse(data.gallery_images) : [];
        gallery = Array.isArray(parsedGallery) ? parsedGallery.filter(Boolean) : [];
      } catch (e) {
        gallery = [];
      }

      data.all_images = data.feature_image
        ? [data.feature_image, ...gallery.filter(image => image !== data.feature_image)]
        : gallery;

      this.setState({
        hotel: data,
        post_booking_status: Number(data.post_booking_status) || 0,
        adults: data.adults ? Math.min(2, data.adults) : 1,
        loading: false,
      });
    } catch (err) {
      console.error('Fetch error:', err);
      this.setState({ error: 'Failed to load property details', loading: false });
    }
  };

  fetchBookedDates = async (postId) => {
    try {
      const res = await axios.get(`/booked_dates?post_id=${postId}`);
      this.setState({ bookedDates: res.data.data || [] });
    } catch (e) {
      console.error('Booked dates fetch error:', e);
    }
  };

  updateRecentlyViewed = (id) => {
    try {
      const stored = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');
      const viewed = (Array.isArray(stored) ? stored : [])
        .filter(item => Number(item) !== Number(id));
      viewed.unshift(id);
      localStorage.setItem('recently_viewed_products', JSON.stringify(viewed.slice(0, 20)));
    } catch (error) {
      // Recently viewed is optional; a malformed local value must not break the page.
      localStorage.setItem('recently_viewed_products', JSON.stringify([id]));
    }
  };

  /* ---------- Booking ---------- */
  handleBooking = async () => {
    const { hotel, checkIn, checkOut, rooms, adults, children, remarks } = this.state;
    const { grandTotal } = this.calculateTotals();
    const web_user_id = localStorage.getItem('web_user_id');

    if (!web_user_id) {
      alert('Please login first');
      return;
    }
    if (!checkIn || !checkOut) {
      alert('Select dates first');
      return;
    }
    if (checkIn >= checkOut) {
      alert('Check-out date must be after check-in date.');
      return;
    }
    if (!this.isDateRangeFree(checkIn, checkOut)) {
      alert('Your selected range contains already booked dates. Please select free dates.');
      return;
    }

    try {
      await axios.post('book_room', {
        post_id: Number(hotel.id),
        customer_id: Number(web_user_id),
        host_id: Number(hotel.customer_id),
        checkin_date: this.getLocalDateString(checkIn),
        checkout_date: this.getLocalDateString(checkOut),
        rooms: Number(rooms),
        adults: Number(adults),
        children: Number(children),
        remarks,
        totalAmount: Number(grandTotal),
      });
      window.location.href = '/chat';
    } catch (e) {
      console.error(e);
      alert('Booking failed');
    }
  };

  handleBookingDirect = async () => {
    const { hotel, rooms, adults, children, remarks } = this.state;
    const { grandTotal } = this.calculateTotals();
    const web_user_id = localStorage.getItem('web_user_id');

    if (!web_user_id) {
      alert('Please login first');
      return;
    }

    try {
      await axios.post('book_room_direct', {
        post_id: hotel ? Number(hotel.id) : '',
        customer_id: web_user_id ? Number(web_user_id) : '',
        host_id: hotel ? Number(hotel.customer_id) : '',
        checkin_date: this.getLocalDateString(new Date()),
        checkout_date: this.getLocalDateString(new Date()),
        rooms: rooms ? Number(rooms) : '',
        adults: adults ? Number(adults) : '',
        children: children ? Number(children) : '',
        remarks: remarks || '',
        totalAmount: grandTotal ? Number(grandTotal) : '',
      });
      window.location.href = '/chat';
    } catch (e) {
      console.error(e);
      alert('Booking failed');
    }
  };

  /* ---------- Date helpers ---------- */
  getLocalDateString = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  isDateBlockedForCheckIn = (date) => {
    const dateStr = this.getLocalDateString(date);
    return this.state.bookedDates.some(b => dateStr >= b.checkin_date && dateStr < b.checkout_date);
  };

  isDateRangeFree = (start, end) => {
    const startStr = this.getLocalDateString(start);
    const endStr = this.getLocalDateString(end);
    return !this.state.bookedDates.some(b => startStr < b.checkout_date && endStr > b.checkin_date);
  };

  formatDateString = (date) => {
    if (!date) return 'Select Date';
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  getNights = () => {
    const { checkIn, checkOut } = this.state;
    if (checkIn && checkOut) return Math.ceil(Math.abs(checkOut - checkIn) / (1000 * 60 * 60 * 24));
    return 0;
  };

  /* ---------- Share / gallery / favorite ---------- */
  copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        this.setState({ copied: true });
        setTimeout(() => this.setState({ copied: false }), 3000);
      })
      .catch(() => console.log('Copy failed'));
  };

  openGallery = (index = 0) => {
    this.setState({ isGalleryOpen: true, currentImageIndex: index });
    document.body.style.overflow = 'hidden';
  };

  closeGallery = () => {
    this.setState({ isGalleryOpen: false });
    document.body.style.overflow = 'unset';
  };

  nextImage = () => this.setState(p => ({
    currentImageIndex: (p.currentImageIndex + 1) % p.hotel.all_images.length,
  }));

  prevImage = () => this.setState(p => ({
    currentImageIndex: p.currentImageIndex === 0 ? p.hotel.all_images.length - 1 : p.currentImageIndex - 1,
  }));

  toggleShareModal = () => this.setState(p => ({ isShareModalOpen: !p.isShareModalOpen }));

  toggleFavorite = () => this.setState(p => ({ isFavorite: !p.isFavorite }));

  /* ---------- Popups (details, policy, rules, report) ---------- */
  openModal = (name) => {
    this.setState({ activeModal: name });
    document.body.style.overflow = 'hidden';
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
      reportForm: { title: '', description: '' },
      reportSubmitting: false,
      reportError: '',
      reportSubmitted: false,
    });
    document.body.style.overflow = 'unset';
  };

  handleReportChange = (e) => {
    const { name, value } = e.target;
    this.setState(p => ({ reportForm: { ...p.reportForm, [name]: value }, reportError: '' }));
  };

  handleReportSubmit = async (e) => {
    if (e) e.preventDefault();
    const { hotel, reportForm } = this.state;
    const customerId = localStorage.getItem('web_user_id');
    const title = reportForm.title.trim();
    const description = reportForm.description.trim();

    if (!customerId) {
      this.setState({ reportError: 'Please login first to report this listing.' });
      return;
    }
    if (!title || !description) {
      this.setState({ reportError: 'Please enter a title and a description.' });
      return;
    }

    this.setState({ reportSubmitting: true, reportError: '' });
    try {
      await axios.post('report_listing', {
        title: title,
        description: description,
        post_id: Number(hotel.id),
        customer_id: Number(customerId),
      });
      
      this.setState({ 
        reportSubmitted: true, 
        reportSubmitting: false,
        reportForm: { title: '', description: '' } 
      });
    } catch (err) {
      console.error('Report error:', err);
      const errorMsg = err.response?.data?.messages?.error || 
                       err.response?.data?.message || 
                       'Failed to submit your report. Please try again.';
      this.setState({ reportError: errorMsg, reportSubmitting: false });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (this.state.activeModal) this.closeModal();
      else if (this.state.isShareModalOpen) this.toggleShareModal();
      else if (this.state.isGuestOpen) this.setState({ isGuestOpen: false });
    }
    if (!this.state.isGalleryOpen) return;
    if (e.key === 'ArrowRight') this.nextImage();
    if (e.key === 'ArrowLeft') this.prevImage();
    if (e.key === 'Escape') this.closeGallery();
  };

  /* ---------- Calendar ---------- */
  handleDayClick = (clickedDate) => {
    const { checkIn, checkOut } = this.state;
    const todayStr = this.getLocalDateString(new Date());
    const clickedStr = this.getLocalDateString(clickedDate);

    if (clickedStr < todayStr) return;

    if (!checkIn || (checkIn && checkOut)) {
      if (this.isDateBlockedForCheckIn(clickedDate)) return;
      this.setState({ checkIn: clickedDate, checkOut: null });
    } else if (clickedDate <= checkIn) {
      if (!this.isDateBlockedForCheckIn(clickedDate)) this.setState({ checkIn: clickedDate });
    } else if (this.isDateRangeFree(checkIn, clickedDate)) {
      this.setState({ checkOut: clickedDate, showSidebarCalendar: false });
    } else if (!this.isDateBlockedForCheckIn(clickedDate)) {
      this.setState({ checkIn: clickedDate });
    }
  };

  changeMonth = (calendarType, offset) => {
    this.setState(p => {
      const current = p[calendarType];
      return { [calendarType]: new Date(current.getFullYear(), current.getMonth() + offset, 1) };
    });
  };

  renderCalendarMonth = (baseDate) => {
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const monthName = baseDate.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    const { checkIn, checkOut } = this.state;
    const todayStr = this.getLocalDateString(new Date());
    const days = [];

    for (let i = 0; i < firstDay; i++) days.push(<div key={`empty-${i}`} className="cal-day empty" />);

    for (let d = 1; d <= daysInMonth; d++) {
      const currentDate = new Date(year, month, d);
      const isPast = this.getLocalDateString(currentDate) < todayStr;
      let isBooked = false;

      if (isPast) {
        isBooked = true;
      } else if (!checkIn || (checkIn && checkOut) || currentDate <= checkIn) {
        isBooked = this.isDateBlockedForCheckIn(currentDate);
      } else {
        isBooked = !this.isDateRangeFree(checkIn, currentDate);
      }

      let statusClass = isBooked ? 'is-unavailable' : '';
      if (checkIn && currentDate.getTime() === checkIn.getTime()) {
        statusClass += ' selected start-date';
      } else if (checkOut && currentDate.getTime() === checkOut.getTime()) {
        statusClass += ' selected end-date';
      } else if (checkIn && checkOut && currentDate > checkIn && currentDate < checkOut) {
        statusClass += ' in-range';
      }

      days.push(
        <button
          type="button"
          key={d}
          className={`cal-day ${statusClass.trim()}`}
          onClick={() => this.handleDayClick(currentDate)}
          disabled={isBooked}
          aria-label={`Select ${currentDate.toDateString()}`}
        >
          {d}
        </button>
      );
    }

    return (
      <div className="calendar-month-wrapper">
        <div className="calendar-month-title">{monthName}</div>
        <div className="cal-weekdays">
          <div>Su</div><div>Mo</div><div>Tu</div><div>We</div><div>Th</div><div>Fr</div><div>Sa</div>
        </div>
        <div className="cal-grid">{days}</div>
      </div>
    );
  };

  /* ---------- Guests & totals ---------- */
  getGuestLimits = (type) => {
    const { hotel } = this.state;
    if (type === 'rooms') return { min: 1, max: Number(hotel.room_number) || 10 };
    if (type === 'adults') return { min: 1, max: Number(hotel.adults) || 10 };
    if (type === 'children') return { min: 0, max: Number(hotel.children) || 10 };
    return { min: 0, max: 10 };
  };

  handleGuestChange = (type, operation) => {
    this.setState(p => {
      const { min, max } = this.getGuestLimits(type);
      let val = p[type];

      if (operation === 'add' && val < max) val++;
      if (operation === 'sub' && val > min) val--;

      return { [type]: val };
    });
  };

  toggleGuestDropdown = () => this.setState(p => ({ isGuestOpen: !p.isGuestOpen, showSidebarCalendar: false }));

  toggleSidebarCalendar = () => this.setState(p => ({ showSidebarCalendar: !p.showSidebarCalendar, isGuestOpen: false }));

  handleOutsideClick = (e) => {
    if (this.state.isGuestOpen && this.guestRef.current && !this.guestRef.current.contains(e.target)) {
      this.setState({ isGuestOpen: false });
    }
  };

  getHostingDuration = (dateStr) => {
    if (!dateStr) return '';

    const start = new Date(dateStr);
    if (Number.isNaN(start.getTime())) return '';

    const diffDays = Math.max(0, Math.floor((new Date() - start) / (1000 * 60 * 60 * 24)));
    const years = Math.floor(diffDays / 365);
    const months = Math.floor((diffDays % 365) / 30);

    if (years > 0) return `${years} ${years === 1 ? 'year' : 'years'} hosting`;
    if (months > 0) return `${months} ${months === 1 ? 'month' : 'months'} hosting`;
    return 'Less than a month hosting';
  };

  getGuestSummary = () => {
    const { rooms, adults, children } = this.state;
    const guests = Number(adults || 0) + Number(children || 0);
    const parts = [`${guests} ${guests === 1 ? 'guest' : 'guests'}`];
    if (Number(rooms) > 1) parts.push(`${rooms} rooms`);
    return parts.join(', ');
  };

  getHostInfo = (hotel, uploadUrl) => {
    const pick = (...keys) => keys
      .map(key => hotel[key])
      .find(value => value !== undefined && value !== null && value !== '');

    const name = pick('host_name', 'full_name') || 'Host';
    const rawRating = Number(pick('host_rating', 'host_ratings', 'customer_rating'));
    const reviewCount = Number(pick('host_reviews', 'host_total_reviews', 'customer_reviews')) || 0;

    return {
      name,
      profileUrl: `/host-profile/${hotel.customer_id || ''}`,
      avatar: hotel.host_image
        ? `${uploadUrl}${hotel.host_image}`
        : `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=0049b0&color=fff`,
      rating: Number.isFinite(rawRating) && rawRating > 0 ? rawRating.toFixed(2) : 'New',
      reviews: reviewCount > 0 ? `${reviewCount} Reviews` : 'No reviews yet',
      tenureValue: pick('host_tenure_value', 'tenure_value') || '—',
      tenureLabel: pick('host_tenure_label', 'tenure_label') || 'Hosting on Bookly',
      responseTime: pick('host_response_time', 'response_time') || 'Not provided',
      languages: pick('host_languages', 'languages', 'customer_languages') || 'Not provided',
    };
  };

  handleInputChange = (e) => this.setState({ [e.target.name]: e.target.value });

  calculateTotals = () => {
    const { hotel, cleaningFee, discount, rooms } = this.state;
    if (!hotel) return { totalNights: 0, roomPrice: 0, grandTotal: 0, pricePerNight: 0 };

    const pricePerNight = Number(hotel.sales_price) || 0;
    const totalNights = this.getNights() || 1;
    const roomPrice = pricePerNight * totalNights * Number(rooms || 1);
    const grandTotal = roomPrice + Number(cleaningFee || 0) - Number(discount || 0);
    return { totalNights, roomPrice, grandTotal, pricePerNight };
  };

  renderModal = (title, body, { wide = false } = {}) => (
    <div className="custom-modal-overlay" onClick={this.closeModal}>
      <div
        className={`bk-modal animate-zoom ${wide ? 'bk-modal-wide' : ''}`}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="bk-modal-header">
          <h4 className="bk-modal-title">{title}</h4>
          <button type="button" className="modal-close-btn" onClick={this.closeModal} aria-label="Close">
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="bk-modal-body">{body}</div>
      </div>
    </div>
  );

  renderActiveModal = () => {
    const { activeModal, hotel, reportForm, reportSubmitting, reportError, reportSubmitted } = this.state;

    if (activeModal === 'details') {
      return this.renderModal(
        'About this place',
        <div className="section-text" dangerouslySetInnerHTML={{ __html: hotel.content }} />,
        { wide: true }
      );
    }

    if (activeModal === 'cancellation') {
      return this.renderModal(
        'Cancellation policy',
        <ul className="policy-list">
          {CANCELLATION_POLICY.map((line, i) => <li key={i}>{line}</li>)}
        </ul>
      );
    }

    if (activeModal === 'rules') {
      return this.renderModal(
        'House rules',
        <ul className="policy-list">
          <li>Check-in after {hotel.checkin_time || ""}</li>
          <li>Checkout before {hotel.checkout_time || ""}</li>
          <li>{hotel.adults || 2} guests maximum</li>
        </ul>
      );
    }

    if (activeModal === 'report') {
      if (reportSubmitted) {
        return this.renderModal(
          'Report this listing',
          <div className="report-success">
            <i className="fas fa-check-circle" />
            <h5>Thanks for your report</h5>
            <p>Our team will review this listing.</p>
            <button type="button" className="bk-primary-btn" onClick={this.closeModal}>Done</button>
          </div>
        );
      }

      return this.renderModal(
        'Report this listing',
        <form className="report-form" onSubmit={this.handleReportSubmit}>
          <div className="report-field">
            <label htmlFor="report-title">Title</label>
            <input
              id="report-title"
              className="report-input"
              type="text"
              name="title"
              maxLength={100}
              placeholder="What is the problem?"
              value={reportForm.title}
              onChange={this.handleReportChange}
            />
            <div className="report-chips">
              {REPORT_REASONS.map(reason => (
                <button
                  type="button"
                  key={reason}
                  className={`report-chip ${reportForm.title === reason ? 'is-selected' : ''}`}
                  onClick={() => this.handleReportChange({ target: { name: 'title', value: reason } })}
                >
                  {reason}
                </button>
              ))}
            </div>
          </div>

          <div className="report-field">
            <label htmlFor="report-description">Description</label>
            <textarea
              id="report-description"
              className="report-textarea"
              rows="5"
              name="description"
              maxLength={1000}
              placeholder="Tell us what's wrong"
              value={reportForm.description}
              onChange={this.handleReportChange}
            />
          </div>

          {reportError && <div className="report-error" role="alert">{reportError}</div>}

          <button type="submit" className="bk-primary-btn" disabled={reportSubmitting}>
            {reportSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      );
    }

    return null;
  };

  render() {
    const {
      hotel, loading, error, checkIn, checkOut, rooms,
      cleaningFee, discount, showSidebarCalendar, isGuestOpen, leftCalendarBase,
      rightCalendarBase, isShareModalOpen, isGalleryOpen, currentImageIndex,
      remarks, copied, socialData, isFavorite, post_booking_status,
    } = this.state;

    if (loading) {
      return (
        <div className="property-details-wrapper">
          <div className="post-detail-state container" role="status" aria-live="polite">
            <span className="post-detail-spinner" />
            <p>Loading property details...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="property-details-wrapper">
          <div className="post-detail-state container">
            <div className="post-detail-error" role="alert">{error}</div>
          </div>
        </div>
      );
    }

    if (!hotel) return null;

    const { totalNights, roomPrice, grandTotal, pricePerNight } = this.calculateTotals();
    const nextMonthBase = new Date(leftCalendarBase.getFullYear(), leftCalendarBase.getMonth() + 1, 1);
    const baseUrl = axios.defaults.baseURL ? axios.defaults.baseURL.replace(/\/api\/?$/, '') : '';
    const uploadUrl = `${baseUrl}/uploads/posts/`;
    const images = Array.isArray(hotel.all_images)
      ? hotel.all_images.filter(Boolean).map(image => `${uploadUrl}${image}`)
      : [];
    const host = this.getHostInfo(hotel, uploadUrl);
    const hostDuration = this.getHostingDuration(hotel.customer_date);
    const isInstant = post_booking_status === 1;
    const hasLongDetails = stripHtml(hotel.content).length > 900;
    const formattedPrice = Number(pricePerNight).toLocaleString('en-BD');

    return (
      <div className="property-details-wrapper">
        {isGalleryOpen && images.length > 0 && (
          <div className="fullscreen-gallery" role="dialog" aria-modal="true" aria-label="Property photo gallery">
            <button type="button" className="gallery-close" onClick={this.closeGallery} aria-label="Close gallery">
              <i className="fas fa-times" />
            </button>
            <div className="gallery-counter">{currentImageIndex + 1} / {images.length}</div>
            <button type="button" className="gallery-nav prev" onClick={this.prevImage} aria-label="Previous image">
              <i className="fas fa-chevron-left" />
            </button>
            <img
              src={images[currentImageIndex]}
              alt={`Property view ${currentImageIndex + 1}`}
              className="gallery-main-img"
            />
            <button type="button" className="gallery-nav next" onClick={this.nextImage} aria-label="Next image">
              <i className="fas fa-chevron-right" />
            </button>
            <div className="gallery-thumbnails" aria-label="Choose a photo">
              {images.map((image, index) => (
                <button
                  type="button"
                  key={`${image}-${index}`}
                  className={`gallery-thumb-button ${currentImageIndex === index ? 'active' : ''}`}
                  onClick={() => this.setState({ currentImageIndex: index })}
                  aria-label={`Show photo ${index + 1}`}
                  aria-pressed={currentImageIndex === index}
                >
                  <img src={image} alt="" className="gallery-thumb" loading="lazy" />
                </button>
              ))}
            </div>
          </div>
        )}

        {isShareModalOpen && (
          <div className="custom-modal-overlay" onClick={this.toggleShareModal}>
            <div
              className="custom-modal share-modal animate-zoom"
              onClick={event => event.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="share-title"
            >
              <div className="share-modal-header">
                <h4 id="share-title">Share this listing</h4>
                <button type="button" className="modal-close-btn" onClick={this.toggleShareModal} aria-label="Close share dialog">
                  <i className="fas fa-times" />
                </button>
              </div>

              <div className="share-property-row">
                {images[0] && <img src={images[0]} alt="Property" className="share-property-image" />}
                <div className="share-property-copy">
                  <h6>{hotel.title}</h6>
                  <p>{hotel.category_name || 'Property listing'}</p>
                </div>
              </div>

              <div className="share-options-grid">
                <a href={socialData.social_link_1 || '#'} target="_blank" rel="noopener noreferrer" className="share-option">
                  <i className="fab fa-facebook" /><span>Facebook</span>
                </a>
                <a href={`https://wa.me/${socialData.whatsapp_number || ''}`} target="_blank" rel="noopener noreferrer" className="share-option">
                  <i className="fab fa-whatsapp" /><span>WhatsApp</span>
                </a>
                <a href={socialData.social_link_2 || '#'} target="_blank" rel="noopener noreferrer" className="share-option">
                  <i className="fab fa-twitter" /><span>Twitter</span>
                </a>
                <a href={`mailto:${socialData.email || ''}`} className="share-option">
                  <i className="fas fa-envelope" /><span>Email</span>
                </a>
              </div>

              <div className="share-copy-row">
                <span>{window.location.href}</span>
                <button type="button" onClick={this.copyToClipboard}>{copied ? 'Copied!' : 'Copy'}</button>
              </div>
            </div>
          </div>
        )}

        {this.renderActiveModal()}

        <div className="container property-container">
          <header className="property-header animate-slide-up">
            <div className="property-header-copy">
              <h1 className="property-title">{hotel.title}</h1>
              <div className="property-header-tags">
                {hotel.category_name && <span className="property-type-badge">{hotel.category_name}</span>}
                {hotel.room_type && <span className="property-type-badge text-purple-bg">{hotel.room_type}</span>}
              </div>
            </div>

            <div className="property-header-actions">
              <div className="property-rating-box">
                <div className="rating-value">
                  <i className="fas fa-star" /> {hotel.ratings || 'New'}
                </div>
                <div className="rating-reviews">Listing rating</div>
              </div>
              <button type="button" className="circle-action" onClick={this.toggleShareModal} aria-label="Share property">
                <i className="fas fa-share-alt" />
              </button>
              <button
                type="button"
                className={`circle-action favorite-action ${isFavorite ? 'is-favorite' : ''}`}
                onClick={this.toggleFavorite}
                aria-label={isFavorite ? 'Remove from saved properties' : 'Save property'}
                aria-pressed={isFavorite}
              >
                <i className={isFavorite ? 'fas fa-heart' : 'far fa-heart'} />
              </button>
            </div>
          </header>

          <div className="property-grid-gallery animate-fade-in">
            <div className="mobile-gallery-top-bar">
              <button
                type="button"
                className="mobile-round-btn"
                onClick={() => this.props.navigate ? this.props.navigate(-1) : window.history.back()}
                aria-label="Go back"
              >
                <i className="fas fa-arrow-left" />
              </button>
              <div className="mobile-gallery-actions">
                <button type="button" className="mobile-share-btn" onClick={this.toggleShareModal} aria-label="Share listing">
                  <i className="fas fa-share-alt" /><span>Share</span>
                </button>
                <button
                  type="button"
                  className={`mobile-round-btn ${isFavorite ? 'is-favorite' : ''}`}
                  onClick={this.toggleFavorite}
                  aria-label={isFavorite ? 'Remove from saved properties' : 'Save listing'}
                  aria-pressed={isFavorite}
                >
                  <i className={isFavorite ? 'fas fa-heart' : 'far fa-heart'} />
                </button>
              </div>
            </div>

            <button
              type="button"
              className="gallery-main"
              onClick={() => images.length && this.openGallery(0)}
              aria-label="Open main property image"
              disabled={!images.length}
            >
              {images[0]
                ? <img src={images[0]} alt="Main property view" fetchPriority="high" decoding="async" />
                : <span className="gallery-empty">No property photos available</span>}
            </button>

            <div className="gallery-side">
              {images.slice(1, 5).map((image, index) => (
                <button
                  type="button"
                  key={`${image}-${index}`}
                  className="gallery-side-item"
                  onClick={() => this.openGallery(index + 1)}
                  aria-label={`Open property photo ${index + 2}`}
                >
                  <img src={image} alt={`Property view ${index + 2}`} loading="lazy" decoding="async" />
                  {index === 3 && images.length > 5 && (
                    <span className="more-images-overlay">+{images.length - 5} more</span>
                  )}
                </button>
              ))}
            </div>

            {images.length > 1 && (
              <button type="button" className="show-all-photos-btn" onClick={() => this.openGallery(0)}>
                <i className="fas fa-th" /> Show all photos
              </button>
            )}
          </div>

          <div className="detail-badges">
            <span className="detail-badge"><i className="fas fa-user-friends" /> {hotel.adults || 0} Guests</span>
            <span className="detail-badge"><i className="fas fa-bed" /> {hotel.bedrooms || hotel.rooms || 1} Bedrooms</span>
            <span className="detail-badge"><i className="fas fa-bed" /> {hotel.beds || 0} Beds</span>
            <span className="detail-badge"><i className="fas fa-bath" /> {hotel.baths || 0} Baths</span>
            <span className="detail-badge"><i className="fas fa-star detail-star" /> {hotel.ratings || 'New'} Rating</span>
          </div>

          <div className="row g-5 property-content-row">
            <main className="col-lg-8 property-main-content animate-slide-up">
              <section className="detail-section">
                <h2 className="section-heading">Details</h2>
                <div
                  className={`section-text ${hasLongDetails ? 'is-clamped' : ''}`}
                  dangerouslySetInnerHTML={{ __html: hotel.content || '' }}
                />
                {hasLongDetails && (
                  <button type="button" className="show-more-btn" onClick={() => this.openModal('details')}>
                    Show more <i className="fas fa-chevron-right" />
                  </button>
                )}
              </section>

              <section className="detail-section">
                <h2 className="section-heading">Check in &amp; Check out</h2>
                <div className="stay-time-grid">
                  <div className="stay-time-card">
                    <span className="stay-time-icon"><i className="fas fa-sign-in-alt" /></span>
                    <div>
                      <span className="stay-time-label">Check-in</span>
                      <strong className="stay-time-value">After {hotel.checkin_time || '—'}</strong>
                    </div>
                  </div>
                  <div className="stay-time-card">
                    <span className="stay-time-icon"><i className="fas fa-sign-out-alt" /></span>
                    <div>
                      <span className="stay-time-label">Check-out</span>
                      <strong className="stay-time-value">Before {hotel.checkout_time || '—'}</strong>
                    </div>
                  </div>
                </div>
              </section>

              <section className="host-section-card" aria-label="Hosted by">
                <div className="host-info-wrapper">
                  <div className="host-avatar">
                    <img
                      src={host.avatar}
                      alt={host.name}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="host-details">
                    <h3 className="host-name">
                      Hosted by{' '}
                      <a target='_blank' href={host.profileUrl} className="host-profile-link">
                        {host.name}
                      </a>
                    </h3>
                    <div className="host-meta">
                      <span className="host-verification-info">
                        <i className="fas fa-check-circle text-success me-1" />
                        Identity verified
                        {hostDuration && <> &bull; {hostDuration}</>}
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="detail-section">
                <div className="section-head-row">
                  <div>
                    <h2 className="section-heading">Select check-in date</h2>
                    <p className="section-subtext">
                      {checkIn && checkOut
                        ? <span className="selected-date-text">Selected: {this.formatDateString(checkIn)} – {this.formatDateString(checkOut)} ({this.getNights()} nights)</span>
                        : 'Minimum stay: 1 night'}
                    </p>
                  </div>
                </div>

                <div className="calendar-box">
                  <button type="button" className="cal-nav-btn cal-nav-left" onClick={() => this.changeMonth('leftCalendarBase', -1)} aria-label="Previous month">
                    <i className="fas fa-chevron-left" />
                  </button>
                  <button type="button" className="cal-nav-btn cal-nav-right" onClick={() => this.changeMonth('leftCalendarBase', 1)} aria-label="Next month">
                    <i className="fas fa-chevron-right" />
                  </button>
                  <div className="calendar-months">
                    <div className="calendar-column">{this.renderCalendarMonth(leftCalendarBase)}</div>
                    <div className="calendar-column calendar-second">{this.renderCalendarMonth(nextMonthBase)}</div>
                  </div>
                  <div className="calendar-footer">
                    <button type="button" className="clear-date-btn" onClick={() => this.setState({ checkIn: null, checkOut: null })}>
                      Clear dates
                    </button>
                  </div>
                </div>
              </section>

              <Facilities postId={this.props.params?.id} />

              {(hotel.map_latitude && hotel.map_longitude) && (
                <section className="detail-section">
                  <h2 className="section-heading">Map</h2>
                  <div className="map-card">
                    <iframe
                      className="map-frame"
                      title="Property location map"
                      src={`https://www.google.com/maps?ll=${hotel.map_latitude},${hotel.map_longitude}&z=14&output=embed`}
                      loading="lazy"
                      allowFullScreen
                    />
                    <div className="map-pin" aria-hidden="true"><i className="bi bi-house-door-fill" /></div>
                  </div>
                </section>
              )}

              <section className="detail-section mh">
                <h2 className="section-heading">Meet Your Host</h2>
                <div className="mh-layout">
                  <div className="mh-card">
                    <div className="mh-profile-col">
                      <div className="mh-avatar-box">
                        <img src={host.avatar} alt={host.name} loading="lazy" decoding="async" />
                      </div>
                      <span className="mh-verified-badge"><i className="fas fa-shield-alt" /> Verified</span>
                      <h3 className="mh-name">
                        <a href={host.profileUrl}>{host.name}</a>
                      </h3>
                    </div>
                    <div className="mh-stats-col">
                      <div className="mh-stat-item">
                        <div className="mh-rating-num"><i className="fas fa-star" /> {host.rating}</div>
                        <div className="mh-subtext">{host.reviews}</div>
                      </div>
                      <div className="mh-stat-item">
                        <div className="mh-big-num">{host.tenureValue}</div>
                        <div className="mh-subtext">{host.tenureLabel}</div>
                      </div>
                    </div>
                  </div>

                  <div className="mh-side">
                    <div className="mh-info-row">
                      <div className="mh-info-icon-box"><i className="far fa-clock" /></div>
                      <div className="mh-info-text">
                        <span className="mh-info-label">Response time</span>
                        <span className="mh-info-val fast-resp">
                          Within 14 minutes
                          {/* {host.responseTime} */}
                          </span>
                      </div>
                    </div>
                    <div className="mh-info-row">
                      <div className="mh-info-icon-box lang-icon"><i className="fas fa-language" /></div>
                      <div className="mh-info-text">
                        <span className="mh-info-label">Languages</span>
                        <span className="mh-info-val">
                          Bangla, English
                          {/* {host.languages} */}
                          </span>
                      </div>
                    </div>
                    <button type="button" className="mh-message-host-btn" onClick={this.handleBookingDirect}>
                      Message host
                    </button>
                  </div>
                </div>
              </section>

              <section className="detail-section things-section">
                <h2 className="section-heading">Things to know</h2>
                <div className="things-grid">
                  <button type="button" className="thing-card" onClick={() => this.openModal('cancellation')}>
                    <span className="thing-head">
                      <i className="far fa-calendar-times" /><span>Cancellation policy</span>
                    </span>
                    <span className="thing-text thing-text-clamp">{CANCELLATION_POLICY[0]}</span>
                    <i className="fas fa-chevron-right thing-arrow" />
                  </button>
                  <button type="button" className="thing-card" onClick={() => this.openModal('rules')}>
                    <span className="thing-head"><i className="fas fa-key" /><span>House rules</span></span>
                    <span className="thing-text">
                      Check-in after {hotel.checkin_time || '—'}<br />
                      Checkout before {hotel.checkout_time || '—'}<br />
                      {hotel.adults || 2} guests maximum
                    </span>
                    <i className="fas fa-chevron-right thing-arrow" />
                  </button>
                </div>
              </section>

              <GuestReviews postId={this.props.params?.id} />
              <PostFAQ postId={this.props.params?.id} />
            </main>

            <aside className="col-lg-4 booking-column" id="booking-sidebar-section">
              <div className="booking-sidebar">
                <div className="booking-card">
                  <div className="booking-price-row">
                    <div className="booking-price-line">
                      <span className="booking-price">BDT {formattedPrice}</span>
                      <span className="booking-unit"> / day</span>
                    </div>
                    <div className={`booking-mode ${isInstant ? 'is-instant' : 'is-manual'}`}>
                      <i className={isInstant ? 'fas fa-bolt' : 'fas fa-clock'} />
                      <span>{isInstant ? 'Instant Book' : 'Manual Approval Required'}</span>
                    </div>
                  </div>

                  <div className="booking-box">
                    <button type="button" className="booking-date-row" onClick={this.toggleSidebarCalendar} aria-expanded={showSidebarCalendar}>
                      <span className="booking-date-cell">
                        <i className="far fa-calendar-alt" />
                        <span className="booking-date-text">
                          <span className="booking-date-label">Check In</span>
                          <span className="booking-date-value">{this.formatDateString(checkIn)}</span>
                        </span>
                      </span>
                      <span className="booking-date-cell">
                        <i className="far fa-calendar-alt" />
                        <span className="booking-date-text">
                          <span className="booking-date-label">Check Out</span>
                          <span className="booking-date-value">{this.formatDateString(checkOut)}</span>
                        </span>
                      </span>
                    </button>

                    {showSidebarCalendar && (
                      <div className="sidebar-calendar-dropdown">
                        <div className="sidebar-calendar-header">
                          <button type="button" className="mini-nav-btn" onClick={() => this.changeMonth('rightCalendarBase', -1)} aria-label="Previous month">
                            <i className="fas fa-chevron-left" />
                          </button>
                          <span>Select dates</span>
                          <button type="button" className="mini-nav-btn" onClick={() => this.changeMonth('rightCalendarBase', 1)} aria-label="Next month">
                            <i className="fas fa-chevron-right" />
                          </button>
                        </div>
                        {this.renderCalendarMonth(rightCalendarBase)}
                        <div className="sidebar-calendar-footer">
                          <button type="button" className="sidebar-close-btn" onClick={() => this.setState({ showSidebarCalendar: false })}>Close</button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="guest-picker" ref={this.guestRef}>
                    <button
                      type="button"
                      className={`guest-trigger ${isGuestOpen ? 'is-open' : ''}`}
                      onClick={this.toggleGuestDropdown}
                      aria-expanded={isGuestOpen}
                    >
                      <i className="far fa-user" />
                      <span className="guest-trigger-text">
                        <span className="guest-trigger-label">Guests</span>
                        <span className="guest-trigger-value">{this.getGuestSummary()}</span>
                      </span>
                      <i className={`fas fa-chevron-${isGuestOpen ? 'up' : 'down'} guest-trigger-arrow`} />
                    </button>

                    {isGuestOpen && (
                      <div className="guest-dropdown animate-zoom">
                        {GUEST_OPTIONS.map(({ type, label, hint }) => {
                          const { min, max } = this.getGuestLimits(type);
                          const value = this.state[type];
                          return (
                            <div className="guest-option" key={type}>
                              <div>
                                <div className="guest-option-title">{label}</div>
                                <div className="guest-option-hint">{hint}</div>
                              </div>
                              <div className="guest-controls">
                                <button type="button" className="qty-btn" disabled={value <= min} onClick={() => this.handleGuestChange(type, 'sub')} aria-label={`Decrease ${label}`}>
                                  <i className="fas fa-minus" />
                                </button>
                                <span className="guest-count">{value}</span>
                                <button type="button" className="qty-btn" disabled={value >= max} onClick={() => this.handleGuestChange(type, 'add')} aria-label={`Increase ${label}`}>
                                  <i className="fas fa-plus" />
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  <div className="remarks-wrapper">
                    <div className="remarks-icon"><i className="far fa-comments" /></div>
                    <div className="remarks-content">
                      <label className="remarks-title" htmlFor="post-detail-remarks">Ask anything you want</label>
                      <textarea
                        id="post-detail-remarks"
                        className="remarks-textarea"
                        rows="3"
                        placeholder="Write something..."
                        name="remarks"
                        value={remarks}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>

                  {checkIn && checkOut && (
                    <div className="price-summary">
                      <div>
                        <span>BDT {formattedPrice} × {totalNights} nights × {rooms} room(s)</span>
                        <strong>BDT {Number(roomPrice).toLocaleString('en-BD', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                      </div>
                      {cleaningFee > 0 && (
                        <div><span>Cleaning fee</span><strong>BDT {Number(cleaningFee).toLocaleString('en-BD')}</strong></div>
                      )}
                      {discount > 0 && (
                        <div className="discount-row"><span>Special Discount</span><strong>− BDT {Number(discount).toLocaleString('en-BD')}</strong></div>
                      )}
                      <div className="summary-divider" />
                      <div className="grand-total">
                        <span>Grand Total</span>
                        <strong>BDT {Number(grandTotal).toLocaleString('en-BD', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                      </div>
                    </div>
                  )}

                  <button type="button" className="reserve-btn" onClick={this.handleBookingDirect}>
                    {isInstant ? 'Reserve Now' : 'Send Booking Request'}
                  </button>
                </div>

                <div className="booking-help">Need help with booking? <a href="/contact">Ask Help &amp; Support</a></div>
                <div className="report-listing">
                  <button type="button" className="report-link" onClick={() => this.openModal('report')}>
                    <i className="far fa-flag" /><span>Report this listing</span>
                  </button>
                </div>
              </div>
            </aside>
          </div>
        </div>

        <div className="mobile-sticky-bar">
          <div className="mobile-sticky-price-info">
            <span className="mobile-price-amount">BDT {formattedPrice}</span>
            <span className="mobile-price-unit"> / day</span>
          </div>
          <button
            type="button"
            className="mobile-sticky-reserve-btn"
            onClick={() => (checkIn && checkOut
              ? this.handleBooking()
              : window.scrollTo({ top: 400, behavior: 'smooth' }))}
          >
            {checkIn && checkOut ? (isInstant ? 'Reserve' : 'Send Request') : 'Select Dates'}
          </button>
        </div>
      </div>
    );
  }
}

export default withNavigation(PostDetail);
